var personaspvid = 0;
var rrevents = [];
var varInit = false;
var hasNewEvents = true;
var socket = null;
var isFirst = true;
var isInACall = false;

console.log("PERSONAS: Initializing rrweb");
// Initialize rrweb to record events
rrweb.record({
    emit: function (event) {
        rrevents.push(event);
        hasNewEvents = true; //isFirst
    }
});


function sendData(data) {

    console.log("PERSONAS: Sending data: " + JSON.stringify(data));

    let domain = 'www.swish-apps.com';
    //let domain = 'localhost:44334';
    var url = 'https://' + domain + '/ping';

    isInACall = true;
    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
        .then(response => {
            if (!response.ok) {
                throw new Error('PERSONAS: Network response was not ok ' + response.statusText);
            }
            return response.json(); // Convert response to text
        })
        .then(rrresult => {
            const pidResult = parseFloat(rrresult.pid); // Parse the text to a number
            if (isNaN(pidResult)) {
                throw new Error('PERSONAS: Response pid is not a valid number');
            }
            personaspvid = pidResult;
            sessionStorage.setItem('personaSessionId', rrresult.sid);
            isInACall = false;
        })
        .catch(error => {
            console.error('PERSONAS: There was a problem with the fetch operation:', error);
            isInACall = false;
        });
}

function sendPing() {
    if (!isInACall) {
        const sessid = sessionStorage.getItem('personaSessionId');
        var rrdata = {
            sid: sessid,
            pid: personaspvid,
            url: window.location.href, // Capture the current page URL
            referrer: document.referrer, // Capture the referrer URL
            useragent: navigator.userAgent, // Capture the user agent string
            events: JSON.stringify(rrevents),
            timestamp: new Date().getTime()
        };
        sendData(rrdata);
    }
}

sendPing();

setInterval(function () {
    if (hasNewEvents) {
        isFirst = false;
        hasNewEvents = false;
        sendPing();
    }
}, 2000);

